// @ts-check
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  inline: {
    display: 'inline'
  }
}));

export function ClientTypeComponent({ client }) {
  const classes = useStyles();
  return (
    <>
      <Typography variant="subtitle2" component="h3" align="center">
        <small>
          <b>Client Type</b>
        </small>
      </Typography>
      <List className={classes.root}>
        <ListItem>
          <ListItemText
            primary={`${client.client_type === 'ON_DEMAND' ? 'On-Demand' : 'Logistics'}`}
          ></ListItemText>
        </ListItem>
      </List>
    </>
  );
}
